import { observable } from "mobx";
import { AppConstants, Types } from "../../../common/APIConstants";
import moment from "moment";
import _ from "lodash";
import GainLossReferenceAPI from "../services/gainloss-reference-screen-service";
import GainLossSubSystemVarianceAPI from "../services/gainloss-subSystemVariance-screen-service";
import GainLossListsScreenAPI from "../services/gainloss-lists-screen-service";
import GainLossTransactionAPI from "../services/gainloss-transaction-screen-service";
import { Column } from "ag-grid-community";
class GainLossSubSystemVarianceDataStore {
  @observable screenRowData = {
    SubSystemVarianceData: [],
  };
  @observable rowData = [];
  @observable screenColumnDefinitions = {
    GainLossSubSystemVarianceScreen: [],
  };
  @observable headerDetails = {
    jurisdictionDpDwnList: [],
  };
  @observable hasScreenData = false;
  @observable selectedData = [];

  @observable selectedJurisdiction = [];
  @observable selectedDivision = [];
  @observable selectedProductionMonth = [];

  @observable division = [];
  @observable productionMonthData = [];

  @observable SubSystemVarianceDataSaved = true;

  @observable headerNames = [
    "District",
    "System",
    "SubSystem",
    "Field Variance Comment",
    "Last Saved By",
    "Last Saved Date",
  ];
  @observable auditData = [];
  @observable showAuditPopUp = false;
  @observable fieldNames = [
    "district",
    "system",
    "subSystem",
    "auditMessage",
    "updatedBy",
    "updatedDate",
  ];
  @observable system = [];
  @observable subSystem = [];
  setAuditPopUp = (value) => {
    this.showAuditPopUp = value;
  };
  getHeaderData = async (CommonStore) => {
    CommonStore.toggleLoader();
    try {
      const { data } = await GainLossReferenceAPI.getReferenceHeaderData();
      this.headerDetails.jurisdictionDpDwnList = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
    }
  };
  resetSubSystemVarianceData = () => {
    this.screenRowData.SubSystemVarianceData = [];
    this.hasScreenData = false;
  };
  getScreenData = async (CommonStore) => {
    CommonStore.toggleLoader();
    this.hasScreenData = false;
    this.screenRowData.SubSystemVarianceData = [];
    this.rowData = [];
    this.selectedData = [];
    try {
      let requestObj = {
        jurisdiction: this.selectedJurisdiction,
        division: this.selectedDivision.value,
        productionMonth: this.selectedProductionMonth.value,
      };
      const { data } =
        await GainLossSubSystemVarianceAPI.getSubSystemVarianceScreenData(
          requestObj
        );
      const SubSystemVarianceData = data?.map((item) => ({
        ...item,
        isActive: item.isActive ? "Active" : "Inactive",
      }));
      this.screenRowData.SubSystemVarianceData = SubSystemVarianceData;
      this.rowData = SubSystemVarianceData;
      this.hasScreenData = true;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes(
          "Data not available for selected jurisdiction"
        )
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };
  resetSubSystemVarianceData = () => {
    this.screenRowData.SubSystemVarianceData = [];
    this.hasScreenData = false;
  };

  setProductionMonths = async (CommonStore) => {
    //CommonStore.toggleLoader();
    try {
      this.productionMonthData = [];
      const { data } = await GainLossTransactionAPI.getProductionMonths();
      Object.values(data).forEach((value) => {
        if (value.isActive === true) {
          this.selectedProductionMonth = {
            value: value.value,
            label: value.label,
          };
        }
      });
      Object.values(data).forEach((value) => {
        this.productionMonthData.push({
          value: value.value,
          label: value.label,
        });
      });
      //CommonStore.toggleLoader();
    } catch (error) {
      //CommonStore.toggleLoader();
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  };

  getEntityName = async (entityType) => {
    const requestData = {
      jurisdiction: this.selectedJurisdiction,
      entityType: "Division/District",
    };
    let { data } = await GainLossListsScreenAPI.getEntityList(requestData);
    this.division = data
      .filter((entity) => entity.isActive)
      .map((entity) => entity.entityName);
  };

  setColumnDef = async (currentScreenChildren, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      currentScreenChildren.forEach((child) => {
        const { screen, screenColumns: columns } = child;

        this.screenColumnDefinitions[child.screen.name] = [];
        this.screenColumnDefinitions[child.screen.name] =
          this.getAllColumnDefinitions(screen, columns);
      });
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes("Data not available for selected date")
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  getAllColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    columns.forEach((column) => {
      gridColumns.push({
        field: column.name,
        headerName: column.title,
        type: "text",
        hide: column.hidden,
        isEditableCol: column.readOnly,
        width: column.width ? column.width : 200,
        required: column.required,

        keyCreator: (params) => {
          return this.getValueFomatter(params, column, screen)
            ? this.getValueFomatter(params, column, screen)
            : params.value;
        },
        editable: () => screen.canEditRow && !column.readOnly,

        cellClassRules: {
          "highlight-cell": (params) => {
            return this.getIsEditable(params, column, screen);
          },
          "grid-cell-custom": (params) => {
            return params.data ? true : false;
          },
        },
        cellRenderer: this.getCellRenderer(column),
        cellRendererParams: (params) =>
          this.getCellRendererParams(column, params),
        cellEditor: this.getCellEditor(column),
        cellEditorParams: (params) => this.getCellEditorParams(column, params),
        valueFormatter: (params) => {
          return this.getValueFomatter(params, column, screen);
        },
        pinned:
          column.name === "division" ||
          column.name === "system" ||
          column.name === "subSystem"
            ? "left"
            : "no",
        comparator:
          column?.type === "decimal"
            ? (valueA, valueB) => valueA - valueB
            : undefined,

        cellStyle: (params) => {
          if (column.readOnly && !params.node.data.isNewRow) {
            return { backgroundColor: "LightGray" };
          }
          if (column.required && params.node.data.isNewRow) {
            return { border: "1px solid red" };
          } else return { "white-space": "normal" };
        },
      });
    });
    return gridColumns;
  };

  getIsEditable(params, column) {
    if (params.data.productTxt !== "") {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      if (moment(params.data["DateTxt"]) < moment(date)) {
        return false;
      }
    }
    if (this.getIsDataReadOnly() || !params.data) return false;
    else {
      return !column.readOnly;
    }
  }
  getIsDataReadOnly() {
    return false;
  }
  getCellRenderer(column) {
    switch (column.type) {
      case Types.BOOLEAN:
        return "booleanCellEditor";
      case Types.DATETIME:
        return "dateTimeFormatter";
      case Types.DATE:
        if (
          column.name === "productionMonth" ||
          column.name === "productionDate"
        )
          return "monthYearFormatter";
        return "dateFormatter";
      case Types.DECIMAL:
        if (
          column.name === "throughput" ||
          column.name === "gainLoss" ||
          column.name === "afterShrinkageGainLoss" ||
          column.name === "unidentifiedGainLoss" ||
          column.name === "gainLossBarrels" ||
          column.name === "maxGainLossBarrels"
        )
          return "decimalFormatter";
        else return "decimalFormatter3Digits";
    }
    if (column.name === "withinTolerance") {
      return "ColorFormatter";
    }
    if(column.name === 'materiality'){
      return "decimalFormatter"
    }
  }
  numberSort(num1, num2) {
    return num1 - num2;
  }
  getCellEditor(column) {
    switch (column.type) {
      case Types.DROPDOWN:
        return "SmartSelectClearable";
      case Types.datetime:
        return "dateTimeFormatter";
      case Types.date:
        return "dateFormatter";
    }
    if (column.name === "varianceComment") return "agLargeTextCellEditor";
  }
  getCellEditorParams = (column, params) => {
    switch (column.type) {
      case Types.DROPDOWN:
        return {
          values: column.refLookupData?.lookupValues.values,
          isPopup: true,
        };
    }
    if (column.name === "varianceComment")
      return { maxLength: 1500, cols: 100, rows: 20 };
  };

  getCellRendererParams(column, params) {
    switch (column.type) {
      case Types.BOOLEAN:
        return { isDisabled: this.getIsDataReadOnly() };
    }
  }

  getValueFomatter(params, column, screen) {
    if (params.value) {
      if (column.type === Types.DROPDOWN && column.refLookupData != null) {
        return this.lookupValue(
          column.refLookupData.lookupValues,
          params.value
        );
      }
    }
  }

  lookupValue(mappings, key) {
    if (
      !mappings ||
      mappings === "undefined" ||
      !mappings.values.find((item) => item.value == key)
    )
      return null;
    else {
      let label = mappings.values.find((item) => item.value == key).label;
      return label;
    }
  }

  getAuditData = async (CommonStore, requestData) => {
    CommonStore.toggleLoader();
    this.auditData = [];
    try {
      let requestObj = {
        subSystemVarianceId: requestData.subSystemVarianceId,
      };

      const { data } =
        await GainLossSubSystemVarianceAPI.getSubSystemVarianceAuditHistory(
          requestObj
        );
      this.system = requestData.system;
      this.subSystem = requestData.subSystem;
      this.auditData = data;
      CommonStore.toggleLoader();
      return data;
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes(
          "Audit Data not available for selected row"
        )
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  saveData = async (CommonStore) => {
    this.SubSystemVarianceDataSaved = false;
    CommonStore.toggleLoader();
    const toAddUpdate = this.selectedData;
    try {
      const addUpdateData = toAddUpdate.map((item) => {
        return item;
      });
      let requestObj = {
        addUpdateData,
      };
      const { data } =
        await GainLossSubSystemVarianceAPI.saveSubSystemVarianceScreenData(
          addUpdateData
        );

      window.toastr.success("SubSystemVariance Data Saved Sucessfully!");
      CommonStore.toggleLoader();

      this.selectedData = [];

      this.SubSystemVarianceDataSaved = true;
    } catch (error) {
      console.log("error:", error.response.data);
      if (error.response.data.includes("Violation of UNIQUE KEY constraint")) {
        window.toastr.error(
          AppConstants.GAINLOSSREFERENCETOASTER_ERROR_DUPLICATE_TEXT
        );
      } else if (
        error.response.data.includes(
          "Effective Start Date can only be the first day of the month for an existing SubSystem"
        )
      ) {
        window.toastr.error(
          AppConstants.GAINLOSS_TOASTER_ERROR_EFFECTIVESTARTDATE_FIRST_DAY_TEXT
        );
      } else
        window.toastr.error(
          AppConstants.GAINLOSSREFERENCETOASTER_ERROR_SAVE_TEXT
        );
      CommonStore.toggleLoader();
    }
  };
}
export default new GainLossSubSystemVarianceDataStore();
